// Stessa soglia della cache di ConnectionService: tornando dopo così tanto i dati vengono riletti dal server
export const AWAY_RELOAD_MS = 5 * 60 * 1000;

/**
 * Chiama `cb` quando la pagina torna visibile dopo almeno `minAwayMs` in background
 * (tipico della PWA sul telefono, che resta sospesa senza ricaricarsi).
 * Ritorna la funzione per smettere di ascoltare.
 */
export function onReturnAfter(minAwayMs: number, cb: () => void): () => void {
  let hiddenAt = 0;
  const handler = () => {
    if (document.hidden) {
      hiddenAt = Date.now();
      return;
    }
    if (hiddenAt && Date.now() - hiddenAt >= minAwayMs) cb();
    hiddenAt = 0;
  };
  document.addEventListener('visibilitychange', handler);
  return () => document.removeEventListener('visibilitychange', handler);
}
